/**
 * Barrel export for timeline components
 * Consolidates exports for cleaner imports
 */

// Main components
export { default as TimelineColumn } from "./timeline-column";
export { default as TimelineDot } from "./timeline-dot";
export { default as TimelineLineSegment } from "./timeline-line-segment";
export { default as PrePostNightAccordion } from "./pre-post-night-accordion";
export { default as ExtensionAccordion } from "./pre-post-tour/extension-accordion";
export { default as DayCard } from "./day-card";
export { default as ExtensionDayCard } from "./pre-post-tour/extension-day-card";
export { default as ShowFullItineraryButton } from "./show-full-itinerary-button";
export { default as DayUpgrades } from "./day-upgrades";
export { default as UpgradeCard } from "./upgrade-card";
export { default as ExcursionCard } from "./excursion-card";

// Upgrade modals
export { ExcursionModal, HotelModal } from "./upgrade-modals";

// Custom hooks
export { useTimelineMeasurements } from "./use-timeline-measurements";

// Types
export type {
  TimelineItem,
  MeasuredPosition,
  UseTimelineMeasurementsReturn
} from "./use-timeline-measurements";
export type { TimelineColumnProps } from "./timeline-column";
export type { TimelineDotProps } from "./timeline-dot";
export type { TimelineLineSegmentProps } from "./timeline-line-segment";
